var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.disabled
        ? _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _vm.orderType !== "6"
                ? _c(
                    "el-col",
                    { attrs: { span: 2 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", icon: "el-icon-edit" },
                          on: { click: _vm.openModal },
                        },
                        [_vm._v("添加商品")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: 2 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", icon: "el-icon-edit" },
                      on: { click: _vm.clearTableData },
                    },
                    [_vm._v("清空")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-scrollbar",
        {
          ref: "myScrollbar",
          staticStyle: { height: "400px" },
          attrs: {
            "wrap-class": "content-scrollbar",
            native: false,
            noresize: false,
            tag: "div",
          },
        },
        _vm._l(_vm.tableData, function (item, k) {
          return _c(
            "div",
            {
              key: k,
              ref: item.key || "productList",
              refInFor: true,
              staticClass: "table-box",
            },
            [
              _c("div", [_vm._v(_vm._s("政策编码:" + item.key))]),
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: {
                    data: item.data,
                    "row-key": (row) => {
                      return row.id + row.productCode + row.lineType
                    },
                    "show-header": k === 0,
                    border: "",
                    size: "mini",
                    "default-expand-all": "",
                    "tree-props": { children: "giftList" },
                  },
                },
                [
                  _vm._l(_vm.tableList, function (item, index) {
                    return _c(
                      "el-table-column",
                      _vm._b(
                        {
                          key: index,
                          attrs: { label: item.title, prop: item.field },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    !item.props.type
                                      ? _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              placement: "top-start",
                                              trigger: "hover",
                                              disabled: !scope.row.isErr,
                                              content: scope.row.calSucessMsg,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "reference" },
                                                slot: "reference",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.analysisField(
                                                      scope,
                                                      item
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : item.props.type === "input"
                                      ? _c(
                                          "div",
                                          [
                                            !scope.row.hideControl &&
                                            !_vm.disabled
                                              ? _c("el-input", {
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder: "请输入内容",
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row[item.field],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        item.field,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row[item.field]",
                                                  },
                                                })
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.analysisField(
                                                        scope,
                                                        item
                                                      )
                                                    )
                                                  ),
                                                ]),
                                          ],
                                          1
                                        )
                                      : item.props.type === "inputNumber"
                                      ? _c(
                                          "div",
                                          [
                                            _c("el-input-number", {
                                              model: {
                                                value: scope.row[item.field],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    item.field,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row[item.field]",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : item.props.type === "select"
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "请选择",
                                                  multiple: "",
                                                  "collapse-tags": "",
                                                  value:
                                                    scope.row.promotionList ||
                                                    [],
                                                },
                                                on: {
                                                  change: (val) =>
                                                    _vm.changeForm(
                                                      val,
                                                      scope,
                                                      k
                                                    ),
                                                },
                                              },
                                              _vm._l(
                                                scope.row.options || [],
                                                function (child) {
                                                  return _c("el-option", {
                                                    key: child.promotionPolicyCode,
                                                    attrs: {
                                                      label:
                                                        child.promotionPolicyName ||
                                                        "",
                                                      value:
                                                        child.promotionPolicyCode ||
                                                        "",
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        "el-table-column",
                        item.props,
                        false
                      )
                    )
                  }),
                  !_vm.disabled
                    ? _c("el-table-column", {
                        attrs: { label: "操作", fixed: "right" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm.clickVisible(scope)
                                    ? _c("i", {
                                        staticClass: "el-icon-delete-solid",
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteProduct(scope)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        }),
        0
      ),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
      _vm.isReplenishment
        ? _c("replenishment", {
            attrs: {
              customerCode: _vm.customerCode,
              backList: _vm.value.tableData,
            },
            on: { closeAdd: _vm.closeAdd, submitAdd: _vm.submitAdd },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }